import React from 'react';
import cn from 'classname';
import _sumBy from 'lodash/sumBy';
import { connect } from 'react-redux';
import moment from 'moment';
import qs from 'qs';

import UpdateApprovalTypeForm from '../forms/update-approval-type';
import { Link } from 'react-router';

const OrdinaryRow = ({
	row, intl, activeRowId, updateType, requestTypes, toggleExpandedRow, approve, decline, setActiveRow, remove,
	can, editedField, openPredefinedForm
}) => (
	<tr
		className={cn({ 'row-done': row.status === 'done', 'row-declined': row.status === 'declined' })}
	>
		<td
			className={`id fixed-col ${cn({
				'col-done': row.status === 'done', 'col-declined': row.status === 'declined',
				'hover-pointer': true
			})}` }
			onClick={toggleExpandedRow.bind(null, row.id)}
		>
			<p><span>{row.manager}</span></p>
			<p><span>{row.affiliate}</span></p>
			<p><span>Affiliate id: ({row.affiliate_id})</span></p>
			<p><span>{row.country}</span></p>
			<p><span>{row.offer}</span> </p>
			{ row.campaign_id && <p><span>{row.campaign_id}</span> </p>}
		</td>
		<td className="approve_request_cell">
			<span>{moment(row.approve_from).format('YYYY-MM-DD')}</span> -
			<span> {moment(row.approve_to).format('YYYY-MM-DD')}</span>
		</td>
		<td className="approve_request_cell">
			<span>{row.created_at}</span>
		</td>
		<td className="approve_request_cell">
			{ row.toApproveCount }
		</td>
		<td className="approve_request_cell">
			{_sumBy(row.leads_by_date, 'total')}
		</td>
		<td className="approve_request_cell">
			{_sumBy(row.leads_by_date, 'pending')}
		</td>
		<td className="approve_request_cell">
			<span>{row.payoutSum} usd</span>
		</td>
		<td className="approve_request_cell">
			<span>{row.sid}</span>
		</td>
		<td className="approve_request_cell">
			<span>{row.target_approve}</span>
		</td>
		<td className="approve_request_cell">
			<span>{Math.floor((row.approve_after || row.approve_after_confirm) * 100)/100} %</span>
		</td>
		<td className="approve_request_cell">
			<span>{Math.floor(row.current_approve_ratio_affiliate)} %</span>
		</td>
		<td className="approve_request_cell">
			<span>{Math.floor(row.approve_by_offer_geo_ratio_affiliate)} %</span>
		</td>
		<td className="approve_request_cell">
			<span>{Math.floor(row.approve_by_offer_geo_ratio)} %</span>
		</td>
		<td className="approve_request_cell">
			<span>{row.reason}</span>
		</td>
		<td
			className={cn({'hover-pointer': row.status && row.status !== 'declined', 'position-relative': true})}
			onClick={setActiveRow.bind(null, row.id, 'type')}
		>
			{
				activeRowId === row.id &&
				editedField === 'type' &&
				row.status && row.status !== 'declined' &&
				<UpdateApprovalTypeForm
					row={row} intl={intl} form={`approve_requests_type_${row.id}`}
					requestTypes={requestTypes}
					requestId={row.id}
					updateType={updateType}
					activeField={'type'}
					setActiveRow={setActiveRow}
					initialValues={{type: [{ value: row.type, label: row.type }]}}
				/>
			}
			<span>{row.type}</span>
		</td>
		<td className="approve_request_cell">
			<span>{row.status}</span>
		</td>
		<td>
			<a href={row.clickup_task_id} target="_blank">{row.clickup_task_status}</a>
		</td>
		<td>
			<span>{Math.round(row.average_affiliate_margin)}</span>
		</td>
		<td>
			<span>{Math.round(row.average_offer_margin)}</span>
		</td>
		<td
			className={cn({'hover-pointer': row.status === 'awaiting', 'position-relative': true})}
			onClick={setActiveRow.bind(null, row.id, 'comment')}
		>
			{
				activeRowId === row.id &&
				editedField === 'comment' &&
				row.status === 'awaiting' &&
				<UpdateApprovalTypeForm
					row={row} intl={intl} form={`approve_requests_type_${row.id}`}
					requestTypes={requestTypes}
					activeField={'comment'}
					requestId={row.id}
					updateType={updateType}
					setActiveRow={setActiveRow}
					initialValues={{type: [{ value: row.type, label: row.type }], comment: row.comment}}
				/>
			}
			<span>{row.comment}</span>
		</td>
		<td>
			<span>{row.status_changed_by}</span>
		</td>
		<td className={`fixed-col-right box-shadow-internal-1 ${cn({
			'col-done': row.status === 'done', 'col-declined': row.status === 'declined'
		})}`}>
			<div className="approve-request-control-buttons-container">
				{
					row.status === 'awaiting' &&
					<p>
						{can('confirm') &&
						<button className="approve-btn" onClick={approve.bind(null, row.id)} ></button>
						}
						{can('confirm') &&
						<button className="decline-btn" onClick={decline.bind(null, row.id)} ></button>
						}
						<button className="remove-btn" onClick={remove.bind(null, row.id)} />
					</p>
				}
				{
					can('confirm') &&
					<p className="margin-top-20">
						<Link
							to={`statistics?${affiliateFilterQuery(row)}`}
							target="_blank"
							className="action_statistics"
						/>
						<a
							href="#"
							onClick={openPredefinedForm.bind(null, row)}
							className="action_add"
						/>
					</p>
				}
			</div>
		</td>
	</tr>
);

const affiliateFilterQuery = row => {
	const query = { filters: {
		affiliates: [row.affiliate_id],
		countries: [row.country_id],
		offers: [row.offer_id]
	},  date_range: {
		start: row.approve_from,
		end: row.approve_to
	}};

	const entity = {
		filters: [{
			name: 'affiliates',
			values: [{ value: row.affiliate_id, label: row.affiliate }]
		}, {
			name: 'offers',
			values: [{ value: row.offer_id, label: row.offer }]
		}, {
			name: 'countries',
			values: [{ value: row.country_id, label: row.country }]
		}],
		date_range: {
			start: row.approve_from,
			end: row.approve_to
		}
	};

	return qs.stringify({ query, entity });
};

export default connect(state => ({ requestTypes: state.root.lists['manual-approve-request-types'] }))(OrdinaryRow);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-approve-requests/components/table/ordinaty-row.js